module.exports = __webpack_public_path__ + "img/list_item_three.2d0b3aea.png";